<script>
export default {
  props: {
    dataList: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {}
  },
  computed: {
    widthPercent() {
      return 100 / this.dataList.items.length
    },
  },
  created() {},
}
</script>
<template>
  <div :class="$style.trainingCard">
    <div class="trainingCard__box">
      <div class="container">
        <div class="trainingCard-box">
          <div v-for="(item, index) of dataList.items" :key="index" class="inner-box" :style="{ width: widthPercent + '%' }">
            <div>
              <img :src="item.icon" alt="" class="img" />
            </div>
            <div class="name">{{ item.title }}</div>
            <div class="text">{{ item.description }}</div>
          </div>
        </div>
        <div v-if="dataList.content" class="learn-text">{{ dataList.content }}</div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" module>
.trainingCard {
  :global {
    .trainingCard {
      &__box {
        .container {
          background-color: #ffffff;
          .trainingCard-box {
            display: flex;
            padding: 70px 10px;
            justify-content: space-between;
            @include max-sm {
              padding: 40px 0px;
            }
            .inner-box {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              border-right: 1px solid $color-gray-3;
              padding: 0px 20px;
              flex: 1 0 0;
              .name {
                font-size: 24px;
                margin-top: 30px;
              }
              .text {
                font-size: 18px;
                color: $color-gray-6;
                margin-top: 16px;
              }
              @include max-md {
                padding: 0px 10px;
                justify-content: flex-start;
                .img {
                  width: 80px;
                  height: 45px;
                }
                .name {
                  font-size: 20px;
                }
                .text {
                  font-size: 12px;
                }
              }
              @include max-sm {
                padding: 0px 8px;
                .name {
                  font-size: 16px;
                  text-align: center;
                }
              }
            }
            .inner-box:nth-last-child(1) {
              border-right: none;
            }
          }
          .learn-text {
            font-size: 18px;
            color: $color-gray-6;
            width: 82%;
            text-align: center;
            margin: -40px auto 0px;
            padding-bottom: 70px;
            line-height: 2;
            @include max-sm {
              font-size: 12px;
              margin: 0 auto;
              padding-bottom: 40px;
              line-height: 2;
            }
          }
        }
      }
    }
  }
}
</style>